module.exports = __webpack_public_path__ + "07dfa1fc979999d86236da19c64f3a02.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-photo/img/large_720x720_noicon.png
// module id = 758
// module chunks = 0